// schema
import * as ISchema from "@schema";

// libraries
import * as React from "react";

// event-scheduler-video-conferencing-input imports
import { IProps, IState } from "./EventSchedulerRecurrenceOptionInput.d";
import { styles } from "./EventSchedulerRecurrenceOptionInput.styles";

// util
// import { getCurrentOrg } from '@util/org.util';

// material-ui
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

///////////////
// Component //
///////////////
class EventSchedulerRecurrenceOptionInputCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      recurrenceOption: props.recurrenceOption || ISchema.RecurrenceOption.None,
    };
  }

  private onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const recurrenceOption = e.target.value as ISchema.RecurrenceOption;
    this.setState({ recurrenceOption });
    if (this.props.onChange) {
      this.props.onChange(recurrenceOption);
    }
  };

  public render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.content}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="cw-recurrence-option">
              Make it recurring?
            </InputLabel>
            <Select
              value={this.state.recurrenceOption}
              onChange={this.onChange}
              name="Make it recurring"
              inputProps={{
                name: "Recurring events",
                id: "cw-recurrence-option",
              }}
              fullWidth
            >
              <MenuItem value={ISchema.RecurrenceOption.None}>Does not repeat</MenuItem>
              <MenuItem value={ISchema.RecurrenceOption.Weekly}>Weekly</MenuItem>
              <MenuItem value={ISchema.RecurrenceOption.Biweekly}>Every 2 weeks</MenuItem>
              <MenuItem value={ISchema.RecurrenceOption.Monthly}>Every month</MenuItem>
              <MenuItem value={ISchema.RecurrenceOption.Bimonthly}>Every 2 months</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////
export const EventSchedulerRecurrenceOptionInput = withStyles(styles)(
  EventSchedulerRecurrenceOptionInputCmpt,
);
